import React, { useContext, useEffect, useState } from 'react'
import {
  PageMainContentContainer,
  PageMainContentPartThree,
  UnderlineActiveButtons,
} from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from '../MentorHeader'
import WebinarsListing from './components/WebinarsListing'
import { MENTOR_WEBINARS_PAGE_VIEWS, fetchWebinarsForMentors } from './webinars-utils'
import { getAllOneOnOnePlans, getMentorBookedSlots } from '../MentorEventsPage/MentorEventsHelpers'
import { allAvailableEventTypes } from 'src/consumer/constants'
import { MentorUpcomingPastEventsTable } from '../MentorEventsPage/MentorEventsComponentsAndHelpers'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { useNavigate } from 'react-router-dom'

export default function MentorWebinarsCreationPage() {
  const { mentorProfileData } = useContext(MentorProfileContext)
  const navigate = useNavigate()

  const [selectedView, setSelectedView] = useState(MENTOR_WEBINARS_PAGE_VIEWS.VIEW_ALL_EVENTS)

  const [bookedWebinars, setBookedWebinars] = useState([])
  const [oneOnOnePlans, setOneOnOnePlans] = useState([])
  const [webinars, setWebinars] = useState([])

  const [loadingDetails, setLoadingDetails] = useState({
    bookedWebinarsLoading: false,
    webinarsList: false,
  })

  async function getBookedWebinars() {
    setLoadingDetails((prev) => ({ ...prev, bookedWebinarsLoading: true }))
    const bookedSlots = await getMentorBookedSlots((val) =>
      setLoadingDetails((prev) => ({ ...prev, bookedWebinarsLoading: val })),
    )
    if (bookedSlots) {
      setBookedWebinars(
        bookedSlots?.filter((item) => item?.eventType === allAvailableEventTypes?.webinar),
      )
    }
    setLoadingDetails((prev) => ({ ...prev, bookedWebinarsLoading: false }))
  }

  async function getOneOnOnePlans() {
    const oneOnOnePlans = await getAllOneOnOnePlans()
    if (oneOnOnePlans) {
      setOneOnOnePlans(oneOnOnePlans)
    }
  }
  async function getWebinars() {
    const webinars = await fetchWebinarsForMentors()
    if (!!webinars) {
      setWebinars(webinars)
    }
  }

  async function WebinarsSetup() {
    setLoadingDetails((prev) => ({ ...prev, webinarsList: true }))
    const promises = [getWebinars(), getOneOnOnePlans()]
    await Promise.all(promises)
    setLoadingDetails((prev) => ({ ...prev, webinarsList: false }))
  }

  async function Setup() {
    const promises = [WebinarsSetup(), getBookedWebinars()]
    await Promise.all(promises)
  }

  useEffect(() => {
    Setup()
  }, [])

  function renderContent() {
    switch (selectedView) {
      case MENTOR_WEBINARS_PAGE_VIEWS.VIEW_ALL_EVENTS:
        return (
          <WebinarsListing
            oneOnOnePlans={oneOnOnePlans}
            setWebinars={setWebinars}
            webinars={webinars}
            loading={loadingDetails?.webinarsList}
            refreshWebinars={getWebinars}
            refreshOneOnOnePlans={getOneOnOnePlans}
          />
        )
      case MENTOR_WEBINARS_PAGE_VIEWS.VIEW_SCHEDULED_EVENTS:
        return (
          <MentorUpcomingPastEventsTable
            allEvents={bookedWebinars}
            loadingSlots={loadingDetails?.bookedWebinarsLoading}
            mentorProfileData={mentorProfileData}
            refreshEvents={getBookedWebinars}
            onClickJoin={(item) => navigate(`/webinar/${item?.id}`)}
            eventFindLogicOverride={(webinarItem, bookedEventItem) =>
              webinarItem?.id === bookedEventItem?.eventTypeId
            }
          />
        )
      default:
        return <WebinarsListing />
    }
  }

  return (
    <>
      <MentorHeader heading="Webinars" />
      <PageMainContentContainer style={{ marginTop: '10px' }}>
        <PageMainContentPartThree style={{ border: '1px solid #CCCCCC' }}>
          <UnderlineActiveButtons
            active={selectedView === MENTOR_WEBINARS_PAGE_VIEWS.VIEW_ALL_EVENTS}
            onClick={() => setSelectedView(MENTOR_WEBINARS_PAGE_VIEWS.VIEW_ALL_EVENTS)}
          >
            Webinars
          </UnderlineActiveButtons>
          <UnderlineActiveButtons
            active={selectedView === MENTOR_WEBINARS_PAGE_VIEWS.VIEW_SCHEDULED_EVENTS}
            onClick={() => setSelectedView(MENTOR_WEBINARS_PAGE_VIEWS.VIEW_SCHEDULED_EVENTS)}
          >
            Scheduled Webinars
          </UnderlineActiveButtons>
        </PageMainContentPartThree>
        {renderContent()}
      </PageMainContentContainer>
    </>
  )
}
